<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Консоль управления</h2>
          <div class="px-3"></div>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card tile flat>
          <v-card-text>
            <v-textarea v-model="itasks" label="вставьте комманды сюда">
            </v-textarea>
            <v-btn
              class="ma-3"
              color="secondary"
              :disabled="itasks.length === 0"
              @click="parseTasks"
            >
              Parse
            </v-btn>
            <v-btn
              class="ma-3"
              color="primary"
              :disabled="inaction === true || tasks.length === 0 || tasks.length > 10000"
              @click="importTasks"
            >
              Go! {{ tasks.length }}
            </v-btn>
            <v-chip v-if="tasks.length > 10000" color="warning darken-1" text-color="white" class="py-1 px-3 ml-3">
              <v-avatar>
                <v-icon>warning</v-icon>
              </v-avatar>
              Слишком много комманд за раз (максимум 10000)
            </v-chip>
            <br />
            <v-card
            flat
            v-for="(task, idx) of tasks" :key="`task-${idx}`"
            class="my-1"
            >
              <v-card-text>
                <h2>#{{idx}} : <b>{{task.topic}}</b> {{task.start}} - {{task.dur}}ms</h2>
                payload: <small>{{JSON.pretty(task.pl)}}</small>
                <br />
                <h4 v-if="task.dur">Результат:</h4>
                <span v-if="task.error" class="fatal--text">
                  {{task.error}}
                </span>
                <code v-else>
                  <small>{{task.result}}</small>
                </code>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Console',
  data: () => ({
    inaction: false,
    itasks: '',
    tasks: [],
  }),
  methods: {
    pretty () {},
    parseTasks () {
      try {
        this.tasks = eval(this.itasks)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async importTasks () {
      this.inaction = true
      for (let task of this.tasks) {
        task.start = moment().format('HH:mm:ss.SSS')
        let st = (new Date()).getTime()
        try {
          const { result, meta } = await this.$store.dispatch('sioRequest', {
            topic: 'exec-task',
            pl: { task }
          })
          task.result = JSON.pretty(result)
          this.$store.dispatch('snack', meta)
        } catch (err) {
          task.error = err
          this.$store.dispatch('snack', err)
        }
        task.dur = (new Date()).getTime() - st
      }
      this.inaction = false
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
  },
  watch: {
    async profile (val) {
    }
  },
  mounted () {
  }
}
</script>

<style>
</style>
